export const COMO_CONHECEU_AGRARE_ENUM = [
  {
    id: 'SOCIAL_MEDIA',
    descricao: "Posts em redes sociais (LinkedIn, Instagram, YouTube etc.)"
  },
  {
    id: 'SEARCH',
    descricao: "Buscando soluções na internet"
  },
  {
    id: 'BLOG',
    descricao: "Li conteúdos no blog"
  },
  {
    id: 'EVENT',
    descricao: "Conheci em um evento"
  },
  {
    id: 'FARM_ALREADY_USES_SYSTEM',
    descricao: "Já utilizamos o sistema na propriedade rural onde atuo"
  },
  {
    id: 'INDICATION',
    descricao: "Indicação de conhecidos"
  },
  {
    id: 'PRESS',
    descricao: "Notícias na imprensa"
  },
  {
    id: 'OTHER',
    descricao: "Outro (especificar)"
  }
];
